import React from 'react'

const Callouts = () => (
<section><a className="anchor"id="callouts"></a>
  <h2>Callouts</h2>
    <p>As of v1.15 callouts have been incorporated into panels.</p>
    <p>Please refer to the <a href="core#panels">Panels</a> section of the library.</p>
  <hr/>
</section>
)

export default Callouts




// WEBPACK FOOTER //
// ./styleguide/components/sections/Callouts.js